export default function Services() {
  const services = [
    {
      icon: 'ri-drop-line',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      title: 'Leak Detection',
      description: 'Advanced thermal imaging and moisture detection technology to identify hidden leaks before they cause major damage.',
      features: [
        'Infrared thermal scanning',
        'Moisture meter analysis',
        'Detailed leak reports'
      ],
      image: 'https://public.readdy.ai/ai/img_res/5a326ca57fc9ff26df805582647cfdea.jpg'
    },
    {
      icon: 'ri-thunderstorms-line',
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600',
      title: 'Storm Damage Repair',
      description: 'Emergency response for hurricane and storm damage with insurance claim assistance and rapid restoration services.',
      features: [
        'Emergency tarping service',
        'Insurance documentation',
        'Complete restoration'
      ],
      image: 'https://readdy.ai/api/search-image?query=damaged%20roof%20shingles%20after%20severe%20storm%20with%20visible%20wind%20and%20hail%20damage%20on%20residential%20property%2C%20dramatic%20lighting%20showing%20broken%20tiles%20and%20structural%20issues%20requiring%20professional%20repair%20services%2C%20realistic%20construction%20damage%20photography&width=600&height=500&seq=service-storm-001&orientation=portrait'
    },
    {
      icon: 'ri-file-list-3-line',
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600',
      title: 'Free Roof Inspections',
      description: 'Comprehensive roof evaluation with detailed photo documentation and written assessment of your roof condition.',
      features: [
        'Complete visual inspection',
        'Photo documentation',
        'Written condition report'
      ],
      image: 'https://readdy.ai/api/search-image?query=professional%20roof%20inspector%20with%20digital%20tablet%20conducting%20thorough%20residential%20roof%20inspection%20on%20sunny%20day%2C%20safety%20equipment%20and%20professional%20attire%20showing%20expertise%20in%20roofing%20assessment%20services%2C%20clean%20modern%20construction%20photography&width=600&height=500&seq=service-inspect-001&orientation=portrait'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border-2 border-orange-600 text-orange-600 text-xs font-bold uppercase tracking-wider mb-4">
            OUR SERVICES
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Complete Roofing Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From minor repairs to complete replacements
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`group bg-white rounded-3xl border-2 border-gray-200 overflow-hidden hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer ${
                index === 0 ? 'md:mt-0' : index === 2 ? 'md:mt-10' : 'md:mt-5'
              }`}
            >
              {/* Image */}
              <div className="relative h-64 w-full overflow-hidden bg-gray-100">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-8">
                {/* Icon */}
                <div className={`w-14 h-14 ${service.iconBg} rounded-full flex items-center justify-center mb-5`}>
                  <i className={`${service.icon} ${service.iconColor} text-2xl`}></i>
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 text-sm leading-relaxed mb-5">
                  {service.description}
                </p>

                {/* Features */}
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start text-sm text-gray-700">
                      <i className="ri-check-line text-orange-600 mr-2 mt-0.5 flex-shrink-0"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* Link */}
                <a
                  href="#contact"
                  className="inline-flex items-center text-orange-600 font-semibold text-sm hover:text-orange-700 transition-colors group/link whitespace-nowrap cursor-pointer"
                >
                  Learn More
                  <i className="ri-arrow-right-line ml-2 group-hover/link:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}